import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

//Pages
import App from './App'
import Splash from './screens/splash'
import Login from './screens/login'
import NotFound from './screens/notfound'
import Terms from './screens/terms'
import PrivacyPolicy from './screens/privacypolicy'

import Players from './screens/players'
import InscriptionForm from './screens/inscriptionForm'
import PlayerSelfAdd from './screens/playerselfadd'
import PlayersBaja from './screens/playersbaja'
import PlayerInfo from './screens/playerinfo'
import PlayerInfoBaja from './screens/playerinfobaja'

import Teachers from './screens/teachers'
import InfoTeacher from './screens/infoteacher'

import Classes from './screens/classes'
import InfoClass from './screens/infoclass'
import AddClass from './screens/addclass'
import SelectSede from './screens/selectsede'

import Sedes from './screens/sedes'
import PanelControl from './screens/panelcontrol'
import Suscriptions from './screens/suscriptions'
import Finances from './screens/finances'
import Assistances from './screens/assitances'
import AssistancesInfo from './screens/assistancesinfo'
import InfoReg from './screens/inforeg'

import SampleClass from './screens/sampleclass'
import ClasesMuestra from './screens/clasesmuestra'
import InscriptionFormMuestra from './screens/inscriptionFormMuestra'

/**
 * PAGINAS PARA COACH
 */
import CoachIndex from './screens/coach/coach-index'
import CoachLogin from './screens/coach/coach-login'
import CoachHome from './screens/coach/coach-home'
import CoachInfoClinic from './screens/coach/coach-info-clinic'
import CoachExtraClass from './screens/coach/coach-extra-class'
import CoachAddClass from './screens/coach/coach-add-class'
import CoachRecords from './screens/coach/coach-records'
import CoachRecordInfo from './screens/coach/coach-record-info'
import CoachInfo from './screens/coach/coach-info'
import CoachInfoExt from './screens/coach/coach-info-ext'
import CoachSettings from './screens/coach/coach-settings'

import ReagendarMuestra from './screens/reagendarmuestra'

//Styles
import './index.css'

const router = createBrowserRouter([
  {
    path: "/",
    element: <Splash />,
    errorElement: <NotFound />
  }, {
    path: "/login",
    element: <Login />,
    errorElement: <NotFound />
  }, {
    path: "/home",
    element: <App />,
    errorElement: <NotFound />
  }, {
    path: "/players",
    element: <Players />,
    errorElement: <NotFound />
  }, {
    path: "/players/add",
    element: <InscriptionForm />,
    errorElement: <NotFound />
  }, {
    path: "/489v57hniehrty9345hy/:ref",
    element: <PlayerSelfAdd />,
    errorElement: <NotFound />
  }, {
    path: "/players/baja",
    element: <PlayersBaja />,
    errorElement: <NotFound />
  }, {
    path: "/players/baja/player",
    element: <PlayerInfoBaja />,
    errorElement: <NotFound />
  }, {
    path: "/players/player",
    element: <PlayerInfo />,
    errorElement: <NotFound />
  }, {
    path: "/teachers",
    element: <Teachers />,
    errorElement: <NotFound />
  }, {
    path: "/teachers/teacher",
    element: <InfoTeacher />,
    errorElement: <NotFound />
  }, {
    path: "/classes",
    element: <Classes />,
    errorElement: <NotFound />
  }, {
    path: "/classes/class",
    element: <InfoClass />,
    errorElement: <NotFound />
  }, {
    path: "/classes/select-sede",
    element: <SelectSede />,
    errorElement: <NotFound />
  }, {
    path: "/classes/add",
    element: <AddClass />,
    errorElement: <NotFound />
  }, {
    path: "/sedes",
    element: <Sedes />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel",
    element: <PanelControl />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/suscriptions",
    element: <Suscriptions />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/finances",
    element: <Finances />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/assistances",
    element: <Assistances />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/assistances/info",
    element: <AssistancesInfo />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/assistances/info/reg",
    element: <InfoReg />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/clasesmuestra",
    element: <ClasesMuestra />,
    errorElement: <NotFound />
  }, {
    path: "/controlpanel/clasesmuestra/registro",
    element: <InscriptionFormMuestra />,
    errorElement: <NotFound />
  }, 

  /**
   * PAGINAS PARA COACH
   */
  {
    path: "/coach",
    element: <CoachIndex />,
    errorElement: <NotFound />
  }, {
    path: "/coach/login",
    element: <CoachLogin />,
    errorElement: <NotFound />
  }, {
    path: "/coach/home",
    element: <CoachHome />,
    errorElement: <NotFound />
  }, {
    path: "/coach/info-clinic",
    element: <CoachInfoClinic />,
    errorElement: <CoachHome />
  }, {
    path: "/coach/extra-class",
    element: <CoachExtraClass />,
    errorElement: <CoachHome />
  }, {
    path: "/coach/add-class",
    element: <CoachAddClass />,
    errorElement: <NotFound />
  }, {
    path: "/coach/records",
    element: <CoachRecords />,
    errorElement: <NotFound />
  }, {
    path: "/coach/record-info",
    element: <CoachRecordInfo />,
    errorElement: <NotFound />
  }, {
    path: "/coach/info",
    element: <CoachInfo />,
    errorElement: <NotFound />
  }, {
    path: "/coach/record-info/ext",
    element: <CoachInfoExt />,
    errorElement: <NotFound />
  }, {
    path: "/coach/settings",
    element: <CoachSettings />,
    errorElement: <NotFound />,
  },

  /**
   * CLASES MUESTRA Y TERMS AND CONDITIONS
   */
  
  {
    path: "/tenista/clasesmuestra",
    element: <SampleClass />,
    errorElement: <NotFound />
  }, {
    path: "/tenista/clasesmuestra/reagendar",
    element: <ReagendarMuestra />,
    errorElement: <NotFound />
  }, {
    path: "/terms",
    element: <Terms />,
    errorElement: <NotFound />
  }, {
    path: "/app/privacy_policy",
    element: <PrivacyPolicy />,
    errorElement: <NotFound />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)
